import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 63171 61846"
    {...props}
  >
    <path
      d="M41713 30918c0 5465-4544 9915-10128 9915-5576 0-10127-4450-10127-9915 0-5459 4551-9902 10127-9902 5587 2 10128 4443 10128 9902zm12776-7086-1595-3791s3710-8368 3381-8692l-4910-4795c-344-331-8715 3489-8715 3489l-3864-1561S35375 0 34905 0h-6932c-479 0-3639 8502-3639 8502l-3855 1565s-8549-3634-8878-3309l-4903 4803c-342 327 3564 8531 3564 8531l-1596 3785S0 27214 0 27665v6792c0 473 8688 3569 8688 3569l1593 3778s-3708 8364-3384 8688l4910 4804c331 327 8709-3494 8709-3494l3867 1566s3412 8478 3883 8478h6932c480 0 3641-8505 3641-8505l3868-1564s8533 3635 8861 3316l4908-4803c344-335-3568-8533-3568-8533l1590-3782s8672-3344 8672-3799l1-6791c1-469-8682-3553-8682-3553z"
      style={{
        fill: "#292525",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
